import { cn } from '@/app/lib';
import { Button } from '@workspace/ui/common';

interface ExpandButtonProps {
  isExpanded?: boolean;
  onClick: () => void;
}

export default function ExpandButton({ isExpanded, onClick }: ExpandButtonProps) {
  return (
    <Button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className="block md:hidden ml-2 cursor-pointer"
      overrideClasses
    >
      <svg
        className={cn('w-4 h-4 transform transition-transform', isExpanded && 'rotate-180')}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </Button>
  );
}
